import { Component, Input } from '@angular/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { getFileNameAndExtension } from '../../../../../../../modules/batch-upload/batch-upload/helpers/helpers';

import { DriverBase } from '../driver-base';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
    standalone: true,
    imports: [NgxDocViewerModule],
})
export class DocumentComponent extends DriverBase {
  mimeTypes: { [key: string]: string } = {
    pdf: 'application/pdf',
    txt: 'text/plain',
    csv: 'text/csv',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    rtf: 'application/rtf',
    html: 'text/html',
    css: 'text/css',
    png: 'image/png',
    jpg: 'image/jpg',
  };
  protected blobUrl: string | undefined;

  @Input() set fileLink(link: string) {
    this.loadFileContent(link, data => {
      const blob = new Blob([data], {
        type: this.mimeTypes[getFileNameAndExtension(link).extension],
      });
      this.blobUrl = URL.createObjectURL(blob);
    });
  }
}
